import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const GA_MEASUREMENT_ID = 'G-9HM0XD7P0Y';

export function usePageTracking() {
    const location = useLocation();

    useEffect(() => {
        if (process.env.NODE_ENV === 'production' && window.gtag) {
            window.gtag('config', GA_MEASUREMENT_ID, {
                page_path: location.pathname + location.search,
                page_title: document.title,
            });
        }
    }, [location]);
}